import React from 'react';
import { read, utils } from 'xlsx';
import { AiOutlineDelete } from "react-icons/ai";
import { Upload, message, notification } from 'antd';

import Button from "../button/index";

import FileUploadIcon from "../../../assets/icons/upload-file.svg";
import FileIcon from "../../../assets/icons/file-icon.svg";

import InfoIcon from "../../../assets/images/newImages/info-icon-blue.svg";
import WarningInfoIcon from "../../../assets/images/newImages/info-icon.svg";

import { UploadUIWrapper } from './style';

const { Dragger } = Upload;

const FileUpload = ({
  // uploadAction = 'https://example.com/upload',
  onFileChange = () => { },
  multiple = true,
  hintText = 'Drop your file here to upload',
  buttonText = 'Browse',
  showUploadedFiles = true,
  setFileData,
  fileList = [],
  setFileList,
  setDataToProceed,
  setFileColumns,
  setFileRows,
  sampleFileLink,
  drawerMobile,
  uploadBulkLocations,
  className,
  withoutWarning,
  downloadSampleTemplate,
  label,
  bulkAdjustFlag,
  showMessage = true
}) => {

  const uploadFile = (info) => {
    setDataToProceed([]);
    setFileColumns([]);
    let fileList = [];
    if (info.fileList.length <= 1) {
      fileList = [...info.fileList];
      fileList = fileList.splice(0, 1);
      if (info.file.status === 'done')
        message.success(`${info.file.name} file uploaded successfully.`);
    } else if (info.fileList.length > 1) {
      fileList = [...info.fileList];
      const index = fileList.findIndex(file => file.name === info.file.name);
      fileList = fileList.splice(index, 1);
    }
    drawerMobile ? setFileList((prev) => [...prev, ...fileList]) : setFileList(fileList);
    !drawerMobile && populateFormFieldsWithFileData(fileList);
  };

  const populateFormFieldsWithFileData = (uploadedFile) => {
    const { originFileObj } = uploadedFile[0];
    const reader = new FileReader();
    reader.readAsBinaryString(originFileObj);
    reader.onload = (({ target }) => {
      const wb = read(target.result, { type: 'binary', raw: true });
      // Only the first sheet holds the data — ignore extra sheets (e.g. a template's Instructions
      // sheet). Matches the backend, which reads SheetNames[0].
      const sheetName = wb.SheetNames[0];
      // The first row is always the header (default sheet_to_json behaviour); data starts at row 2.
      const rawJson = sheetName ? utils.sheet_to_json(wb.Sheets[sheetName], { defval: '' }) : [];
      // Drop fully-empty rows (trailing/blank lines) and any header row echoed into the data
      // (every cell equals its own column name) so blank/header rows don't show as bogus errors.
      const fileJson = rawJson.filter((r) => {
        const keys = Object.keys(r);
        if (!keys.length) return false;
        const allEmpty = keys.every((k) => `${r[k] ?? ''}`.trim() === '');
        const headerEcho = keys.every((k) => `${r[k] ?? ''}`.trim() === `${k}`.trim());
        return !allEmpty && !headerEcho;
      });
      if (fileJson && fileJson.length) {
        const fileColumns = Object.keys(fileJson[0]);
        setFileData({
          rows: fileJson,
          columns: fileColumns
        });
      } else {
        notification.error({
          message: 'File Error',
          description: 'Found an invalid or empty file'
        });
        setFileData({ rows: [], columns: [] });
        setFileRows([]);
        setFileColumns([]);
        setFileList([]);
      }
    });
  };

  const uploadProps = {
    showUploadList: false,
    accept: drawerMobile ? '.png, .jpg, jpeg' : '.csv, .xlsx',
    onChange: (info) => {
      uploadFile(info)
    },
    name: 'file',
    multiple: drawerMobile ? true : false,
    onRemove: () => {
      !drawerMobile && setFileList([]);
    },
    beforeUpload() {
      return false;
    }
  };

  const handleFileDelete = (fileToDelete) => {
    drawerMobile ? setFileList((prev) => prev.filter((file) => file !== fileToDelete)) : setFileList([]);
  };
  return (
    <UploadUIWrapper className={drawerMobile ? "drawer-mobile-upload" : className}>
      {label && <label>{label}</label>}
      <Dragger {...uploadProps}>
        {
          drawerMobile ?
            <div className='mobile-drawer-dragger'>
              <img src={FileUploadIcon} alt="Upload Icon" title="Upload Icon" />
              <p>Drag & Drop or Click to Upload images</p>
            </div>
            :
            <>
              <img src={FileUploadIcon} alt="Upload Icon" title="Upload Icon" />
              <p className="ant-upload-text">{hintText}</p>
              {
                (sampleFileLink || downloadSampleTemplate) && <p className="text-primary d-flex demo-file-text justify-content-center align-items-center gap-1">
                  <a
                    href={sampleFileLink || ''}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary d-flex align-items-center gap-1"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (!sampleFileLink) {
                        e.preventDefault();
                        downloadSampleTemplate();
                      }
                    }}
                  >
                    <img src={InfoIcon} alt="info" />
                    <span className="fs-12 fw-semibold">Download Sample File</span>
                  </a>      </p>
              }
              <Button className="outlined" text={buttonText} />
            </>}
      </Dragger>
      {
        showMessage ?
          drawerMobile ? null : withoutWarning ? null : <p className="text-grey d-flex align-items-center gap-1">
            <img src={WarningInfoIcon} alt="warning" />
            <span className="fs-12 fw-semibold">
              {`Same ${uploadBulkLocations ? 'Location' : 'Item'} cannot be added twice.`}
            </span>
          </p>
          : null
      }
      {
        bulkAdjustFlag && (
          <p className="text-grey d-flex align-items-center gap-1">
            <img src={WarningInfoIcon} alt="warning" />
            <span className="fs-12 fw-semibold">
              This process adjusts the inventory by deducting the specified quantity from the provided SKU.
            </span>
          </p>
        )
      }

      {
        showUploadedFiles && (
          <>
            <h6>Uploaded Files</h6>
            <div className="uploaded-file-container">
              {fileList?.map((file) => (
                <div key={file.uid} className="uploading-content-data">
                  <div className="title">
                    <img src={FileIcon} alt="File Icon" title="File Icon" />
                    <span>{file.name}</span>
                  </div>
                  <AiOutlineDelete onClick={() => handleFileDelete(file)} style={{ cursor: 'pointer', color: 'red' }} />
                </div>
              ))}
            </div>
          </>
        )
      }
    </UploadUIWrapper >
  );
};

export default FileUpload;
